import { Product } from '@commercetools/frontend-domain-types/product/Product';
import ProductSlider, { ProductSliderProps } from 'components/commercetools-ui/organisms/product/product-slider';
import { useProduct } from 'frontastic/hooks';
import { useCallback, useEffect, useState } from 'react';
import usePermissionsChecker from 'helpers/hooks/usePermissionsChecker';
import { toUIProductSlider } from 'helpers/mappers/toUIProductSlider';
import { SustainabilityItem } from 'components/commercetools-ui/types';
import { TasticWithCMS } from 'types/tastic';

export interface DataCmsProps {
  fields: SustainabilityItem;
}

function ProductFeaturedSliderTastic({ data, customerGroup }: TasticWithCMS<any, unknown, DataCmsProps>) {
  const { getProductsByCategories } = useProduct();
  const [products, setProducts] = useState<Product[]>([]);
  const [properties, setProperties] = useState<ProductSliderProps>();
  const { filterByTags, getFields, checkItemPermission } = usePermissionsChecker();

  const getProducts = useCallback(async () => {
    const categories = data?.data?.dataSource?.items?.[0]?.fields?.categoryLinks;
    const filteredCategories = filterByTags(categories, customerGroup)?.map(getFields);
    const products = (await getProductsByCategories(filteredCategories?.[0]?.categoryLinks)) as Product[];

    const props = toUIProductSlider(filteredCategories?.[0]);
    setProperties(props);
    setProducts(products);
  }, [data?.data?.dataSource?.items, filterByTags, customerGroup, getFields]);

  useEffect(() => {
    getProducts();
  }, [getProducts]);
  const { mobile, tablet, desktop, ...props } = data;

  const getSustainability = (data: any, customerGroup: any) => {
    const certificationsItem = data?.cmsDataCertifications?.dataSource?.items?.find(
      (item: DataCmsProps) => item?.fields?.icons?.length,
    );
    const environmentalItem = data?.cmsDataEnvironmental?.dataSource?.items?.find(
      (item: DataCmsProps) => item?.fields?.icons?.length,
    );

    const fieldsCertificationsItem =
      certificationsItem && checkItemPermission(certificationsItem, customerGroup)
        ? getFields(certificationsItem)
        : undefined;

    const fieldsEnvironmentalItem =
      environmentalItem && checkItemPermission(environmentalItem, customerGroup)
        ? getFields(environmentalItem)
        : undefined;

    return {
      certificationsItem: fieldsCertificationsItem,
      environmentalItem: fieldsEnvironmentalItem,
    };
  };

  const sustainability = getSustainability(data, customerGroup);

  return products?.length > 0 ? (
    <ProductSlider {...properties} products={products} sustainability={sustainability} dataTestId="featured" />
  ) : (
    <></>
  );
}

export default ProductFeaturedSliderTastic;
